import { CompanionObservation, ObservationKind, PreviewItem } from './health-companion.service';

/** Kinds whose value is a number (mirrors HealthCompanionObservation::NUMERIC_KINDS). */
export const NUMERIC_KINDS: ReadonlySet<string> = new Set([
  'weight', 'blood_pressure', 'heart_rate', 'sleep_hours', 'sleep_quality', 'hydrogen_water', 'wellbeing', 'mood', 'energy', 'stress'
]);

/** The labelled scale of a rating kind: [max, label key]. Never silently converted. */
export const SCALE_MAX: Record<string, number> = { sleep_quality: 10, wellbeing: 10, mood: 5, energy: 5, stress: 5 };

export const DEFAULT_UNITS: Record<string, string> = {
  blood_pressure: 'mmHg', heart_rate: 'bpm', sleep_hours: 'h'
};

function num(v: unknown): string {
  if (v === null || v === undefined || v === '') return '';
  const n = typeof v === 'number' ? v : parseFloat(String(v));
  if (Number.isNaN(n)) return String(v);
  return Number.isInteger(n) ? String(n) : n.toFixed(1).replace(/\.0$/, '');
}

/** Human value of an observation / preview item, without the kind label. */
export function formatValue(o: Pick<PreviewItem, 'kind' | 'state' | 'value' | 'value2' | 'unit' | 'text'> |
                            Pick<CompanionObservation, 'kind' | 'state' | 'value' | 'value2' | 'unit' | 'text'>): string {
  if (o.state === 'skipped') return '—';
  if (o.kind === 'blood_pressure') return `${num(o.value)}/${num(o.value2)} ${o.unit ?? 'mmHg'}`.trim();
  if (NUMERIC_KINDS.has(o.kind)) {
    const max = SCALE_MAX[o.kind];
    return max ? `${num(o.value)} / ${max}` : `${num(o.value)} ${o.unit ?? ''}`.trim();
  }
  return o.text ?? '';
}

export function isNumericKind(kind: ObservationKind | string): boolean { return NUMERIC_KINDS.has(kind); }
